import { ChangeEvent, CSSProperties } from 'react';
import classNames from 'classnames';
import styles from './Toggle.module.scss';

export interface ToggleProps {
  onChange?: (newState: boolean, event: ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  value?: boolean;
  scale?: string;
  disabled?: boolean;
}

function Toggle({
  onChange,
  scale = '1rem',
  value = false,
  disabled,
  ...props
}: ToggleProps) {
  return (
    <div
      {...props}
      className={classNames(
        styles.container,
        props.className,
        value && styles.checked,
      )}
      style={{ '--toggle-scale': scale } as CSSProperties}
    >
      <input
        onChange={(...args) => onChange?.(!value, ...args)}
        className={styles.input}
        checked={value}
        type="checkbox"
        disabled={disabled}
      />
      <div className={styles.dot} />
    </div>
  );
}

export default Toggle;
